<template>
  <div class="grid-x">
    <div id="main-content-content" class="cell auto grid-x">
      <router-view class="cell auto" id="app-router-view" v-slot="{ Component }">
        <transition name="route" mode="out-in">
          <component :is="Component"></component>
        </transition>
      </router-view>
    </div>
    <transition name="sidebar">
      <sidebar v-if="ui.isSidebarOpen && !isMobile" id="main-content-sidebar" class="cell max-width-sidebar-content" />
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from 'vue'

import { uiOptions } from '@/config'
import { authenticationInformation } from '@/oidc/authentication'
import Sidebar from '@/components/App/Sidebar'

export default defineComponent({
  components: {
    Sidebar,
  },
  name: 'Content',
  setup() {
    const isMobile = ref(false)

    const checkMobile = () => {
      isMobile.value = window.innerWidth < 768
    }

    onMounted(() => {
      checkMobile()
      window.addEventListener('resize', checkMobile)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
    })
    
    return {
      ui: uiOptions(),
      isMobile,
      ...authenticationInformation(),
    }
  },
})
</script>

<style lang="scss" scoped>
/* sidebar transitions */
.sidebar-enter-from,
.sidebar-leave-to {
  opacity: 0;
  transform: translateX(120px);
}

.sidebar-enter-active,
.sidebar-leave-active {
  transition: all 0.4s ease;
}

/* route transitions */
.route-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

#main-content-content {
  z-index: 0;
  max-height: 100%;
  overflow: auto;
}

#app-router-view {
  max-height: 100%;
}

.max-width-sidebar-content {
  max-width: $sidebar-width-expanded;
}

#main-content-sidebar {
  background-color: $primary-color;
  border-left: 1px $secondary-color solid;

  @include breakpoint(medium down) {
    width: 100%;
  }

  @include fc-collapse-border;

  color: white;
  z-index: 0;
}
</style>
